// Registry of the shared grammar explanation components.
//
// Topic lesson JSONs reference a grammar point by slug
// ({ type: "grammarexplanation", grammarPoint: "passive" }) and
// TopicsRouter looks the component up here, so a topic page and its
// matching grammar-exercises page always show the same explanation.
//
// Keys are the grammar-point slugs used by the grammar lesson pages
// (src/Mainpages/Grammar-Exercises/grammar-pages/*).
import AdjAdvExplanation from '../grammar-pages/adj-adv-explanation';
import CauseEffectExplanation from '../grammar-pages/cause-effect-explanation';
import CollocationsExplanation from '../grammar-pages/collocations-explanation';
import ComparisonExplanation from '../grammar-pages/comparison-explanation';
import ComparisonsExplanation from '../grammar-pages/comparisons-explanation';
import ConditionalsExplanation from '../grammar-pages/conditionals-explanation';
import DependentPrepositionsExplanation from '../grammar-pages/dependent-prepositions-explanation';
import DescriptiveAdjectivesExplanation from '../grammar-pages/descriptive-adjectives-explanation';
import DeviceVerbsExplanation from '../grammar-pages/device-verbs-explanation';
import EdIngExplanation from '../grammar-pages/ed-ing-explanation';
import FirstCondExplanation from '../grammar-pages/first-cond-explanation';
import FutureExplanation from '../grammar-pages/future-explanation';
import GerundsExplanation from '../grammar-pages/gerunds-explanation';
import GerundsInfinitivesExplanation from '../grammar-pages/gerunds-infinitives-explanation';
import IndirectSpeechExplanation from '../grammar-pages/indirect-speech-explanation';
import InfinitivesExplanation from '../grammar-pages/infinitives-explanation';
import IntroductionsExplanation from '../grammar-pages/introductions-explanation';
import LinkingWordsExplanation from '../grammar-pages/linking-words-explanation';
import MixedConditionalsExplanation from '../grammar-pages/mixed-conditionals-explanation';
import ModalsDeductionExplanation from '../grammar-pages/modals-deduction-explanation';
import CanExplanation from '../grammar-pages/can-explanation';
import MustHaveToExplanation from '../grammar-pages/must-have-to-explanation';
import MoneyIdiomsExplanation from '../grammar-pages/money-idioms-explanation';
import PassiveExplanation from '../grammar-pages/passive-explanation';
import PassiveBeingExplanation from '../grammar-pages/passive-being-explanation';
import PassiveGetExplanation from '../grammar-pages/passive-get-explanation';
import PassiveReportingExplanation from '../grammar-pages/passive-reporting-explanation';
import PastContinuousExplanation from '../grammar-pages/past-continuous-explanation';
import PastHabitsExplanation from '../grammar-pages/past-habits-explanation';
import PerfectPastExplanation from '../grammar-pages/perfect-past-explanation';
import PresentContinuousExplanation from '../grammar-pages/present-continuous-explanation';
import PresentPerfectExplanation from '../grammar-pages/present-perfect-explanation';
import PresentPerfectContinuousExplanation from '../grammar-pages/present-perfect-continuous-explanation';
import PossessivesExplanation from '../grammar-pages/possessives-explanation';
import ProvideVerbExplanation from '../grammar-pages/provide-verb-explanation';
import PunctuationExplanation from '../grammar-pages/punctuation-explanation';
import RelativeClausesExplanation from '../grammar-pages/relative-clauses-explanation';
import ReportedSpeechExplanation from '../grammar-pages/reported-speech-explanation';
import SecondCondExplanation from '../grammar-pages/second-cond-explanation';
import SenseVerbsExplanation from '../grammar-pages/sense-verbs-explanation';
import SimpContExplanation from '../grammar-pages/simp-cont-explanation';
import SimplePastExplanation from '../grammar-pages/simple-past-explanation';
import SimplePresentExplanation from '../grammar-pages/simple-present-explanation';
import SoEnoughExplanation from '../grammar-pages/so-enough-explanation';
import SomeAnyExplanation from '../grammar-pages/some-any-explanation';
import SuggestExplanation from '../grammar-pages/suggest-explanation';
import TenseExplanation from '../grammar-pages/tense-explanation';
import ThirdCondExplanation from '../grammar-pages/third-cond-explanation';
import ToBePastExplanation from '../grammar-pages/to-be-past-explanation';
import ToBePresentExplanation from '../grammar-pages/to-be-present-explanation';
import UnlessExplanation from '../grammar-pages/unless-explanation';
import UsedToExplanation from '../grammar-pages/used-to-explanation';
import WishExplanation from '../grammar-pages/wish-explanation';
import WordFormsExplanation from '../grammar-pages/word-forms-explanation';
import ZeroConditionalExplanation from '../grammar-pages/zero-conditional-explanation';

const grammarExplanations = {
  'adj-adv': AdjAdvExplanation,
  'cause-effect': CauseEffectExplanation,
  collocations: CollocationsExplanation,
  comparison: ComparisonExplanation,
  comparisons: ComparisonsExplanation,
  conditionals: ConditionalsExplanation,
  'dependent-prepositions': DependentPrepositionsExplanation,
  'descriptive-adjectives': DescriptiveAdjectivesExplanation,
  'device-verbs': DeviceVerbsExplanation,
  'ed-ing': EdIngExplanation,
  'first-cond': FirstCondExplanation,
  future: FutureExplanation,
  gerunds: GerundsExplanation,
  'gerunds-infinitives': GerundsInfinitivesExplanation,
  'indirect-speech': IndirectSpeechExplanation,
  infinitives: InfinitivesExplanation,
  introductions: IntroductionsExplanation,
  'linking-words': LinkingWordsExplanation,
  'mixed-conditionals': MixedConditionalsExplanation,
  can: CanExplanation,
  'modals-deduction': ModalsDeductionExplanation,
  'must-have-to': MustHaveToExplanation,
  'money-idioms': MoneyIdiomsExplanation,
  passive: PassiveExplanation,
  'passive-being': PassiveBeingExplanation,
  'passive-get': PassiveGetExplanation,
  'passive-reporting': PassiveReportingExplanation,
  'past-continuous': PastContinuousExplanation,
  'past-habits': PastHabitsExplanation,
  'perfect-past': PerfectPastExplanation,
  'present-continuous': PresentContinuousExplanation,
    'present-perfect': PresentPerfectExplanation,
    'present-perfect-continuous': PresentPerfectContinuousExplanation,
    'possessives': PossessivesExplanation,
    'provide-verb': ProvideVerbExplanation,
  punctuation: PunctuationExplanation,
  'relative-clauses': RelativeClausesExplanation,
  'reported-speech': ReportedSpeechExplanation,
  'second-cond': SecondCondExplanation,
  'sense-verbs': SenseVerbsExplanation,
  'simp-cont': SimpContExplanation,
  'simple-past': SimplePastExplanation,
  'simple-present': SimplePresentExplanation,
  'so-enough': SoEnoughExplanation,
  'some-any': SomeAnyExplanation,
  suggest: SuggestExplanation,
  tense: TenseExplanation,
  'third-cond': ThirdCondExplanation,
  'to-be-past': ToBePastExplanation,
  'to-be-present': ToBePresentExplanation,
  unless: UnlessExplanation,
  'used-to': UsedToExplanation,
  wish: WishExplanation,
  'word-forms': WordFormsExplanation,
  'zero-conditional': ZeroConditionalExplanation,
};

export default grammarExplanations;
